import angular from "angular";

let Settings = angular.module("Settings", []).constant(
  "Settings",
  (() => {
    "ngInject";

    const operatorTypes = {
      EOT: "eot",
      SAAF: "saaf",
    };

    const Settings = {
      DEBUG: window.env.DEBUG || false,
      PREF_LANGUAGE: window.env.PREF_LANGUAGE || "en",
      OPERATOR: window.env.APP_OPERATOR || operatorTypes.SAAF,
      OPERATORS: operatorTypes,
    };

    return Settings;
  })()
).name;

export default Settings;



// WEBPACK FOOTER //
// ./client/app/constants/settings.js